<template>
  <div class="overview">

    <!-- Header -->
    <header class="header">
      <div class="header__container flex-space">
        <a href="/">
          <h1>vim.is</h1>
        </a>
      </div>
    </header>

    <main class="ov-page">
      <div class="ov-wrap">

        <!-- Title -->
        <div class="ov-hero">
          <h2 class="ov-title">Curriculum</h2>
          <p class="ov-sub">{{ total }} exercises in {{ modules.length }} modules. Work through them in order, or jump to any lesson.</p>
          <a class="ov-start" href="/exercise/0">Start at exercise 1</a>
        </div>

        <!-- Jump links -->
        <nav class="ov-chips" aria-label="Modules">
          <a v-for="(m, i) in modules" :key="'c' + i" class="ov-chip" :href="'#module-' + (i + 1)">
            <span class="ov-chip-n">{{ i + 1 }}</span>{{ m.name }}
          </a>
        </nav>

        <!-- Modules -->
        <section v-for="(m, i) in modules" :key="'m' + i" :id="'module-' + (i + 1)" class="ov-mod" :class="{ 'ov-mod--boss': isBoss(m), 'ov-mod--speed': isSpeed(m) }">
          <details open>
            <summary class="ov-mod-head">
              <span class="ov-mod-num">{{ i + 1 }}</span>
              <span class="ov-mod-text">
                <span class="ov-mod-name">{{ m.name }}</span>
                <span class="ov-mod-blurb">{{ m.blurb }}</span>
              </span>
              <span class="ov-mod-count">{{ m.lessons.length }} lessons</span>
            </summary>

            <ol class="ov-list">
              <li v-for="l in m.lessons" :key="l.idx">
                <a class="ov-lesson" :href="'/exercise/' + l.idx">
                  <span class="ov-lesson-n">{{ pad(l.idx + 1) }}</span>
                  <span class="ov-lesson-t">{{ l.title }}</span>
                </a>
              </li>
            </ol>
          </details>
        </section>

      </div>
    </main>
  </div>
</template>

<script>
import router from '../router'
import curriculum from '../curriculum.json'

export default {
  name: 'OverView',
  metaInfo: {
    title: 'Vim Exercises & Curriculum - vim.is'
  },
  data: function() {
    return {
      modules: curriculum.modules,
      total: curriculum.total
    }
  },
  created: function() {
    var key = this.$cookie.get('key');
    if (key === null)
      router.replace("/login");
  },
  methods: {
    pad: function(n) {
      return ('00' + n).slice(-3);
    },
    isBoss: function(m) {
      return m.name.indexOf('Boss') === 0;
    },
    isSpeed: function(m) {
      return m.name.indexOf('Speed') === 0;
    }
  }
}
</script>

<style scoped>
@import '../assets/hero/css2.css';
@import '../assets/hero/normalize.css';
@import '../assets/hero/style.css';
@import '../assets/hero/responsive.css';

.overview {
  overflow-x: hidden;
  background: #f8fafc;
  min-height: 100vh;
}

.ov-page {
  padding: 32px 16px 80px;
}

.ov-wrap {
  max-width: 1100px;
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;
}

.ov-mod,
.ov-mod * {
  text-align: left;
}

.ov-wrap *,
.ov-wrap *::before,
.ov-wrap *::after {
  box-sizing: border-box;
}

/* ---- title ---- */
.ov-hero {
  text-align: center;
  margin-bottom: 28px;
}

.ov-title {
  font-size: 40px;
  line-height: 1.15;
  margin: 0 0 10px;
  color: #0f172a;
}

.ov-sub {
  font-size: 17px;
  line-height: 1.5;
  color: #475569;
  margin: 0 auto 18px;
  max-width: 560px;
}

.ov-start {
  display: inline-block;
  background: #5f4dee;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 12px 22px;
  border-radius: 10px;
  text-decoration: none;
}

.ov-start:hover {
  background: #4b3bd6;
}

/* ---- chips ---- */
.ov-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin: 0 0 32px;
}

.ov-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 6px 12px 6px 6px;
  font-size: 14px;
  color: #334155;
  text-decoration: none;
  line-height: 1.2;
}

.ov-chip:hover {
  border-color: #5f4dee;
  color: #5f4dee;
}

.ov-chip-n {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eef0ff;
  color: #5f4dee;
  font-size: 12px;
  font-weight: 700;
}

/* ---- module card ---- */
.ov-mod {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  margin-bottom: 18px;
  scroll-margin-top: 16px;
  overflow: hidden;
}

.ov-mod-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  cursor: pointer;
  list-style: none;
}

.ov-mod-head::-webkit-details-marker {
  display: none;
}

.ov-mod-num {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #5f4dee;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.ov-mod-text {
  flex: 1 1 0;
  min-width: 0;
}

.ov-mod-name {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.25;
}

.ov-mod-blurb {
  display: block;
  margin-top: 3px;
  font-size: 15px;
  line-height: 1.45;
  color: #64748b;
}

.ov-mod-count {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 600;
  color: #5f4dee;
  background: #eef0ff;
  border-radius: 999px;
  padding: 4px 10px;
  white-space: nowrap;
}

.ov-mod--boss .ov-mod-num {
  background: #e11d48;
}

.ov-mod--boss .ov-mod-count {
  color: #e11d48;
  background: #ffe4ea;
}

.ov-mod--speed .ov-mod-num {
  background: #0f172a;
}

/* ---- lessons ---- */
.ov-list {
  list-style: none;
  margin: 0;
  padding: 4px 14px 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 6px;
  text-align: left;
}

.ov-list li {
  margin: 0;
  padding: 0;
  min-width: 0;
}

.ov-lesson {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 9px;
  text-decoration: none;
  color: #1e293b;
  font-size: 15px;
  line-height: 1.35;
}

.ov-lesson:hover {
  background: #f1f0ff;
  color: #4b3bd6;
}

.ov-lesson-n {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
  min-width: 28px;
}

.ov-lesson-t {
  min-width: 0;
  overflow-wrap: anywhere;
}

/* the site header is fixed at 768px and below, so leave room for it */
@media (max-width: 768px) {
  .ov-page {
    padding-top: 100px;
  }
}

/* ---- small screens ---- */
@media (max-width: 640px) {
  .ov-page {
    padding: 100px 12px 60px;
  }
  .ov-title {
    font-size: 32px;
  }
  .ov-sub {
    font-size: 16px;
  }
  .ov-chips {
    display: none;
  }
  .ov-mod-head {
    flex-wrap: wrap;
    padding: 14px;
  }
  .ov-mod-count {
    flex: 0 0 100%;
    margin: 0 0 0 54px;
    padding: 0;
    background: none;
    border-radius: 0;
  }
  .ov-mod-name {
    font-size: 18px;
  }
  .ov-list {
    grid-template-columns: 1fr;
    padding: 2px 8px 12px;
  }
}
</style>
